module.exports = __webpack_public_path__ + "images/assets/19934c4e8af1d91fb0d2832c86e5293d.svg";